import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const courseMembershipApi = generateNomenApi(`/course/course-membership`);

export const courseMembershipOptions = generateNomenOptions('course-membership', courseMembershipApi);
